export default __webpack_public_path__ + "static/celebration2-ba839f18638515f8eb698be4098f1ca0.webp";